import React, { useState, useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { createTheme } from '@mui/material/styles';
import Login from "./Auth/Login";
import RealLogin from "./Auth/RealLogin";
import Otp from "./Auth/Otp";
import Home from "./profile/Home";
import Menu from "./profile/FlowChart";
import LayoutProfile from "./profile/LayoutProfile";
import NavBarProfile from "./profile/NavBarProfile";
import HomePage from "./home/HomePage";
import FormInfoPersonalPage from './profile/FormInfoPersonalPage'
import FormInfoHousePage from './profile/FormInfoHousePage'
import FormStateDesc from './profile/FormStateDesc'
import FormDocuments from './profile/FormDocuments'
import FormTerms from './profile/FormTerms'
function AppContent() {

  return (
    <>
     <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/home' element={<Home />} />
            <Route path='/login' element={<Login />} />
            <Route path='/login-user' element={<RealLogin />} />
            <Route path='/otp' element={<Otp />} />
            <Route path='/menu' element={<Menu />} />
            <Route path='/navbar' element={<Login />} />
            <Route path='/profile' element={<LayoutProfile />} />
            <Route path='/pro' element={<NavBarProfile />} />

            <Route path='/InputInfoPersonal' element={<FormInfoPersonalPage />} />
            <Route path='/InputInfoHouse' element={<FormInfoHousePage />} />
             <Route path='/InputInfoDesc' element={<FormStateDesc />} />
            <Route path='/InputDocuments' element={<FormDocuments />} />
            <Route path='/InputTerms' element={<FormTerms />} />
          </Routes>
    </>
  );
}
export default AppContent;